import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type PerioPositionIndicatorStatus = 'active' | 'inactive' | 'done' | 'touched' | 'extracted';

@Component({
  selector: 'lib-perio-position-indicator-tooth',
  imports: [CommonModule],
  templateUrl: './perio-position-indicator-tooth.component.html',
  styleUrl: './perio-position-indicator-tooth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioPositionIndicatorToothComponent {
  public toothStatus = input.required<PerioPositionIndicatorStatus>();
  public toothClick = output<void>();

  protected onToothClick(): void {
    this.toothClick.emit();
  }
}
